import Api from './api_base'

export default {
  // POST /sunday_teachers
  post: (id) => {
    return Api.post('/sunday_teachers', {teacher_id: id})
  },
  // DELETE /sunday_teachers/{teacher_id}
  delete: (id) => {
    return Api.delete('/sunday_teachers/' + id)
  }
}



// WEBPACK FOOTER //
// ./src/api/sunday_teachers.js